export default function generateSerialNumber(): string {
  const digits = Array.from({length: 8}, () => Math.floor(Math.random() * 10));
  const serial = digits.map(i => i.toString()).join('');
  return serial;
}
